import { application } from "./application"

import HelloController from "./hello_controller"
import ChartController from "./chart_controller"
import TooltipController from "./tooltip_controller"
import SelectController from "./select_controller"
import ToastController from "./toast_controller"
import DatepickerController from "./datepicker_controller"
import PhoneMaskController from "./phone_mask_controller"
import AutosubmitController from "./autosubmit_controller"
import MonthDetailController from "./month_detail_controller"
import CopyController from "./copy_controller"
import SidebarController from "./sidebar_controller"
import MobileNavController from "./mobile_nav_controller"
import DrawerController from "./drawer_controller"
import ThemeController from "./theme_controller"
import CascadeController from "./cascade_controller"
import PercentTotalController from "./percent_total_controller"
import DisclosureController from "./disclosure_controller"
import LightboxController from "./lightbox_controller"
import MoneyInputController from "./money_input_controller"
import PageEditorController from "./page_editor_controller"
import ContactPickController from "./contact_pick_controller"
import SidePanelController from "./side_panel_controller"
import PasswordRulesController from "./password_rules_controller"

application.register("hello", HelloController)
application.register("chart", ChartController)
application.register("tooltip", TooltipController)
application.register("select", SelectController)
application.register("toast", ToastController)
application.register("datepicker", DatepickerController)
application.register("phone-mask", PhoneMaskController)
application.register("autosubmit", AutosubmitController)
application.register("month-detail", MonthDetailController)
application.register("copy", CopyController)
application.register("sidebar", SidebarController)
application.register("mobile-nav", MobileNavController)
application.register("drawer", DrawerController)
application.register("theme", ThemeController)
application.register("cascade", CascadeController)
application.register("percent-total", PercentTotalController)
application.register("disclosure", DisclosureController)
application.register("lightbox", LightboxController)
application.register("money-input", MoneyInputController)
application.register("page-editor", PageEditorController)
application.register("contact-pick", ContactPickController)
application.register("side-panel", SidePanelController)
application.register("password-rules", PasswordRulesController)
